// src/lib/axios.js
import axios from "axios";

/** 1) Resolve base URL safely */
const ENV_URL = process.env.REACT_APP_API_BASE_URL || "";

const isBrowser = typeof window !== "undefined";
const isLocalhost = isBrowser && window.location.hostname === "localhost";

/**
 * Priority:
 * - If env var set => use it (must be HTTPS in prod)
 * - Else if localhost => local API
 * - Else => same-origin "/api" (no mixed content, no CORS headaches)
 */
export const API_BASE_URL = ENV_URL
  ? `${ENV_URL.replace(/\/$/, "")}/api`
  : isLocalhost
  ? "http://localhost:5003/api"
  : "/api";

/** For absolute links (downloads, images, etc.) */
export const SERVER_URL =
  API_BASE_URL === "/api" ? "" : API_BASE_URL.replace(/\/api\/?$/, "");

/** Back-compat alias used elsewhere in your app */
export const SERVER_ORIGIN = SERVER_URL;

/** 2) Single axios instance */
export const axiosInstance = axios.create({
  baseURL: API_BASE_URL,
  withCredentials: true,
  timeout: 20000,
});

/** 3) Interceptors */
axiosInstance.interceptors.request.use((config) => {
  try {
    const token = isBrowser ? localStorage.getItem("token") : null;
    if (token) {
      config.headers = config.headers || {};
      config.headers.Authorization = `Bearer ${token}`;
    }
    const method = (config.method || "get").toLowerCase();
    const hasBody = ["post", "put", "patch", "delete"].includes(method);
    const isFormData =
      typeof FormData !== "undefined" && config.data instanceof FormData;
    if (hasBody && !isFormData) {
      if (!config.headers) config.headers = {};
      if (!config.headers["Content-Type"]) {
        config.headers["Content-Type"] = "application/json";
      }
    }
  } catch {}
  return config;
});

export default axiosInstance